import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const situaciones = [
  { id: 0, nombre: "ACTIVO" },
  { id: 1, nombre: "PARADO" },
  { id: 2, nombre: "JUBILADO" },
  { id: 3, nombre: "OTROS" },
];

const SelectSituacionProfesional = ({ name, value, onChange }) => (
  <FormControl fullWidth>
    <InputLabel id={`${name}-label`}>Situación Profesional</InputLabel>
    <Select
      labelId={`${name}-label`}
      name={name}
      value={value}
      onChange={onChange}
    >
      {situaciones.map((s) => (
        <MenuItem key={s.id} value={s.id}>
          {s.nombre}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default SelectSituacionProfesional;
